import styled from 'styled-components';

export const Wrapper = styled.div``;

export const InfoTextWrapper = styled.div`
	display: flex;
	justify-content: left;
	p {
		padding-left: 1rem;
	}
`;

export const CtaBoxWrapper = styled.div`
	/* display: flex;
	flex-direction: row; */
	margin-top: 10rem;
`;
